<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>New Pin Type</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">
                What's the name of the Pin Type?
              </div>
              <v-text-field
                v-model="name"
                hide-details
                dense
                outlined
                placeholder="Pin Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="pr-1">
              <div class="subtitle-2 mb-1">Icon Font Family</div>
              <v-text-field
                v-model="fontFamily"
                hide-details
                dense
                outlined
                placeholder="Icon Font Family"
              ></v-text-field>
            </v-flex>
            <v-flex class="pl-1">
              <div class="subtitle-2 mb-1">Icon Name</div>
              <v-text-field
                v-model="fontName"
                hide-details
                dense
                outlined
                placeholder="Icon Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="pr-1">
              <div class="subtitle-2 mb-1">Background Color</div>
              <v-text-field
                v-model="backgroundColor"
                hide-details
                dense
                outlined
                placeholder="Ex: #4287f5"
              ></v-text-field>
            </v-flex>
            <v-flex class="pl-1">
              <div class="subtitle-2 mb-1">Icon Color</div>
              <v-text-field
                v-model="fontColor"
                hide-details
                dense
                outlined
                placeholder="Ex: #4287f5"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex xs6 class="pr-1">
              <div class="subtitle-2 mb-1">Display Priority</div>
              <v-select
                :items="ranks"
                v-model="displayPriority"
                label="Display Priority"
                dense
                outlined
              ></v-select>
            </v-flex>
          </v-layout>
          <gallery-image-select-section @imageSelected="galleryImageSelected" />
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import GalleryImageSelectSection from '@/modules/Assets/components/GalleryImageSelectSection';
export default {
  components: {
    GalleryImageSelectSection,
  },
  data() {
    return {
      dialog: false,
      name: '',
      fontFamily: '',
      fontName: '',
      backgroundColor: '',
      fontColor: '',
      imageUrl: '',
      displayPriority: 0,
    };
  },
  computed: {
    ranks() {
      let ranksArray = [];
      for (let i = 1; i < 21; i++) {
        ranksArray.push(i);
      }
      return ranksArray;
    },
    changeFields() {
      return {
        name: this.name,
        fontFamily: this.fontFamily,
        fontName: this.fontName,
        backgroundColor: this.backgroundColor,
        fontColor: this.fontColor,
        logo: this.imageUrl,
        displayPriority: this.displayPriority,
      };
    },
  },
  methods: {
    ...mapActions({
      createNewPinType: '$_home/createNewContent',
      getPinTypes: '$_home/getContent',
    }),
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    galleryImageSelected(image) {
      console.log('Image Selected: ', image);
      this.imageUrl = image.url;
    },
    cancel() {
      this.name = '';
      this.fontFamily = '';
      this.fontName = '';
      this.backgroundColor = '';
      this.fontColor = '';
      this.displayPriority = 0;
      this.dialog = false;
    },
    save() {
      console.log(this.changeFields);
      this.createNewPinType({
        details: this.changeFields,
        collection: 'pinTypes',
        type: 'Pin',
      }).then(() => {
        this.cancel();
        this.getPinTypes({
          collection: 'pinTypes',
          mutation: 'updatePinTypes',
        });
      });
    },
  },
};
</script>

<style></style>
